import { ButtonProps as OriginalButtonProps } from "../Button/button.props"

interface ButtonProps extends Omit<OriginalButtonProps, 'type'> {
    type?: "button" | "reset" | "submit";
    bgColor?: string;
    minWidth?: string;
    cusInterestType?: boolean;
}

const AGButtonV2: React.FC<ButtonProps> = ({
    color = "#0971A2",
    bgColor,
    icon,
    iconRight,
    children,
    hasHover = true,
    disabled = false,
    type,
    witdh,
    minWidth,
    clasNameCus,
    cusInterestType = false,
    ...props
}) => {

    return !cusInterestType ? <button
        type={type}
        disabled={disabled}
        className={`relative disabled:opacity-40 group disabled:cursor-not-allowed flex justify-center items-center px-[22px] py-[8px] mr-[10px] last:mr-0 rounded-[20px] text-[#0971A2]  cursor-pointer border-[1px]  border-solid group gap-[10px]
            ${hasHover ? "customDesktop:hover:bg-[#0971A2] customDesktop:hover:text-white" : !bgColor ? "bg-[#ffffff]" : ""}
            `}
        style={{
            borderColor: color,
            width: witdh ?? "",
            backgroundColor: bgColor,
            minWidth: minWidth ?? ""
        }}
        {...props}
    >
        {icon && <div>{icon}</div>}
        {children}
        {iconRight && <div>{iconRight}</div>}
    </button>
        :
        <button
            type={type}
            disabled={disabled}
            className={`relative disabled:opacity-40 group disabled:cursor-not-allowed flex justify-center items-center pl-[22px] pr-[10px] py-[8px] mr-[10px] last:mr-0 rounded-[20px] text-[#0971A2]  cursor-pointer border-[1px]  border-solid group gap-[10px]
            ${hasHover ? "customDesktop:hover:bg-[#0971A2] customDesktop:hover:text-white" : !bgColor ? "bg-[#ffffff]" : ""}
            `}
            style={{
                borderColor: color,
                width: witdh ?? "",
                backgroundColor: bgColor,
                minWidth: minWidth ?? ""
            }}
            {...props}
        >
            {children}
            {iconRight && <div>{iconRight}</div>}
        </button>
}

export default AGButtonV2